const translations = {
    title: 'Equipment'
};

export default translations;
